import React, {useRef} from "react";
import {Button, Columns, Heading, Modal, Section} from "react-bulma-components";
import PrintMovementNote from "./PrintMovementNote";
import PrintGoodsDelivery from "./PrintGoodsDelivery";
import ReactToPrint from "react-to-print";



export default function PrintOptionsModal({movement, open, setOpen}){

    const movementRef = useRef();
    const goodsRef = useRef();

    return (
        <Modal
            show={open}
            closeOnBlur
            onClose={() => setOpen(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Which Print Out:</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <ReactToPrint
                                  trigger={() => (
                                    <Button
                                      color={"warning"}
                                    >
                                      Print Goods Note
                                    </Button>
                                  )}
                                  content={() => goodsRef.current}
                                  bodyClass="print-portrait"
                                  pageStyle="@page {
                                    size: A4 portrait;
                                  }"
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <ReactToPrint
                                  trigger={() => (
                                    <Button
                                      color={"warning"}
                                    >
                                      Print Movement Note
                                    </Button>
                                  )}
                                  content={() => movementRef.current}
                                  bodyClass="print-portrait"
                                  pageStyle="@page {
                                    size: A4 portrait;
                                  }"
                            />
                        </Columns.Column>
                    </Columns>
                </Section>
                <div>
                    <div style={{display: "none"}}>
                        <PrintMovementNote movement={movement} ref={movementRef}/>
                    </div>
                    <div style={{display: "none"}}>
                        <PrintGoodsDelivery movement={movement} ref={goodsRef}/>
                    </div>
                </div>
            </Modal.Content>
        </Modal>
    )

}